module.exports = __webpack_public_path__ + "static/media/8.6061e7c6.png";